import { ProductCard } from '@/src/packages/components/ui/ProductCard';
import { SwiperSlide } from 'swiper/react';
import { PageSection } from '@/src/packages/components/ui/PageSection';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import { Carousel } from '@/src/packages/components/ui/Carousel';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';

export const ProductCompleteTheLook = () => {
  const {
    productVariant: { completeTheLook },
  } = useProductContext();

  if (completeTheLook.length === 0) return <></>;

  return (
    <PageSection>
      <PageSectionTitle>Complete the look</PageSectionTitle>

      <Carousel
        leftFlush
        isFlush
        slidesPerView={1.2}
        breakpoints={{
          800: { slidesPerView: 3 },
        }}
      >
        {completeTheLook.map((product, i) => {
          return (
            <SwiperSlide key={i}>
              <ProductCard productVariant={product} />
            </SwiperSlide>
          );
        })}
      </Carousel>
    </PageSection>
  );
};
